<template>
  <div class='zp_con'>
    <div class='block1 w_1200 text_center'>
      <h3>{{ $t('about.joinUs.title') }}</h3>
      <div class='smalltext' v-html='$t("about.joinUs.desc")'></div>
      <div class='text_left'>
        <div class='img_li'><div class='img_box img_box1'><img src='@/assets/img/Mask@2x.png' height='50%' alt='' class='img1'></div></div>
        <div class='img_li2 fz_0'>
          <div class='img_box img_box2'><img src='@/assets/img/Rectangle@2x(1).png' class='img2' alt=''></div>
          <div class='img_box img_box3'><img src='@/assets/img/Rectangle Copy 17@2x.png' class='img3' alt=''></div>
          <div class='img_box img_box4'><img src='@/assets/img/Rectangle Copy 18@2x.png' class='img4' alt=''></div>
        </div>
      </div>
    </div>
    <div class='block2 w_1200'>
      <div class='menu text_center'>
        <div class='menu_item' :class='!currId ? "cur":""' @click='getDepJobs(0)'>{{ $t('about.joinUs.all') }}</div>
        <div v-for='item in depData' :key='item.id' class='menu_item' :class='item.id === currId ? "cur":""' @click='getDepJobs(item.id)'>{{ item.name }}</div>
      </div>
      <ul class='fz_0'>
        <li v-for='item in jobs' :key='item.id'>
          <div @click='toDetail(item)'>
            <h3>{{ item.title }}</h3>
            <div class='text ellipsis'>{{ item.summary }}</div>
            <div class='tag'>
              <span v-if='item.education'>{{ item.education }}</span>
              <span v-if='item.years'>{{ item.years }}</span>
            </div>
            <div class='addit cf'>
              <div class='fl'>
                <!-- <i></i><span>市场</span> -->
                <span>{{ item.city }}</span>
              </div>
              <div class='fr date'>{{ item.date }}</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { setTitle } from 'utils'
import { getAllDepartments, getDepartmentDetail } from '@/service'

export default {
  name: 'Home',
  components: { },
  data () {
    return {
      depData: [],
      jobs: [],
      currId: '0',
      page: 1,
      limit: 20,
    }
  },
  beforeMount () {
    setTitle(`${this.$t('home.logo')} - ${this.$t('about.joinUs.title')}`)
  },
  mounted () {
    getAllDepartments().then(res => {
      this.depData = res.data
    })
    this.getDepJobs(0)
  },
  methods: {
    getDepJobs (id) {
      this.currId = id
      getDepartmentDetail({ page: this.page, limit: this.limit, id: id }).then(res => {
        this.jobs = res.data.items
      })
    },
    toDetail (item) {
      this.$router.push({ path: '/recruitDetail?id=' + item.id })
    },
  },
}
</script>
